import axios, { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API from "src/services/consts/CaptureWhatsAppInterest";

export function sendCaptureWpInterestFormApiRequest(data: any): Promise<AxiosResponse> {
    return axiosInstance.post(`${API.URL_CAPTURE_WP_INTEREST}`, { ...data }).then((d: AxiosResponse) => d.data);
}

